module.exports = __webpack_public_path__ + "img/photo-24.6e7719c7.jpg";